import { HiOutlineCog6Tooth } from 'react-icons/hi2';
export default function SelectPercentage({
  setPercentage,
  toggleModal
}: {
  setPercentage: (num: number) => void;
  toggleModal: () => void;
}) {
  return <div className='flex items-center justify-center space-x-4 mt-6' data-sentry-component="SelectPercentage" data-sentry-source-file="SelectPercentage.tsx">
      <div onClick={() => setPercentage(10)} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
        <p className='m-auto'>10%</p>
      </div>
      <div onClick={() => setPercentage(25)} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
        <p className='m-auto'>25%</p>
      </div>
      <div onClick={() => setPercentage(50)} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
        <p className='m-auto'>50%</p>
      </div>
      <div onClick={() => setPercentage(100)} className='bg-genius-blue rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
        <p className='m-auto'>All</p>
      </div>
      <div onClick={toggleModal} className='h-[32px] w-[32px] cursor-pointer border-genius-blue border-[1px] rounded-full text-sm flex items-center justify-center ta-c text-genius-cream'>
        <HiOutlineCog6Tooth className='w-[16px]' data-sentry-element="HiOutlineCog6Tooth" data-sentry-source-file="SelectPercentage.tsx" />
      </div>
    </div>;
}